import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import store, { AppStoreModule } from '@/store';
import { TenantSummary } from '@/common/models';
import IAdminService from '@/services/http/interfaces/IAdminService';

export interface ITenantsState {
  tenants: TenantSummary[];
  filter: string;
  currentPage: number;
}

@Module({
  name: 'tenants',
  namespaced: true,
})
export default class TenantsStore extends VuexModule implements ITenantsState {

  // State
  tenants: TenantSummary[] = [];
  filter: string = '';
  currentPage = 0;

  // Getters
  get filteredTenants(): TenantSummary[] {
    const filterAsLowercase: string = this.filter.toLowerCase();

    return this.tenants.filter((t) =>
      (t.name && t.name.toLowerCase().includes(filterAsLowercase)) ||
      (t.email && t.email.toLowerCase().includes(filterAsLowercase)) ||
      (t.cidn && t.cidn.toLowerCase().includes(filterAsLowercase)));
  }

  // Mutations
  @Mutation
  SET_TENANT_SUMMARY(tenants: TenantSummary[]) {
    this.tenants = tenants;
  }

  @Mutation
  SET_FILTER(filter: string) {
    this.currentPage = 0;
    this.filter = filter;
  }

  @Mutation
  SET_CURRENT_PAGE(currentPage: number) {
    this.currentPage = currentPage;
  }

  // Actions
  @Action
  async getTenants(adminService: IAdminService) {

    AppStoreModule.SET_ISLOADING(true);

    await adminService.getTenants()
      .then((tenants: TenantSummary[]) => {
        this.SET_TENANT_SUMMARY(tenants);
      })
      .catch(() => {
        AppStoreModule.SAVE_HTTP_ERROR('Unable to load tenants');
      })
      .finally(() => {
        AppStoreModule.SET_ISLOADING(false);
      });
  }

  @Action
  setFilter(filter: string) {
    this.SET_FILTER(filter);
  }

  @Action
  setCurrentPage(currentPage: number) {
    this.SET_CURRENT_PAGE(currentPage);
  }
}
